import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import styles from './ReviewSection.module.scss';

import { appendBasePath } from '../../utils/nav.utils';

const ReviewSection = ({ step, edit, lineType, content, ...props }) => {
  const editStep = (step, props) => {
    switch (step) {
      case 'Delivery':
        props.history.push(appendBasePath('/destination'));
        break;
      case 'Distribution Method':
        props.history.push(appendBasePath('/distribution'));
        break;
      case 'Frequency':
        props.history.push(appendBasePath('/frequency'));
        break;
      case 'Income Tax Withholding':
        props.history.push(appendBasePath('/tax-withholding'));
        break;
      default:
        break;
    }
  };

  return (
    <div className={styles['review-section-container']}>
      <div className={styles['header-container']}>
        {step.label + ':'}
        {edit && (
          <div className={styles['header-edit']}>
            <button
              id={`review-edit-${step.label}-label`}
              onClick={() => editStep(step.label, props)}
            >
              {'Edit ' + step.label}
            </button>
          </div>
        )}
        {edit && (
          <div className={styles['header-edit-phone']}>
            <button
              id={`review-edit-${step.label}`}
              onClick={() => editStep(step.label, props)}
            >
              {'Edit'}
            </button>
          </div>
        )}
      </div>
      {content}
      {lineType && <hr className={styles['horizontal-line-' + lineType]} />}
    </div>
  );
};

ReviewSection.defaultProps = {
  edit: false,
  lineType: null,
};

ReviewSection.propTypes = {
  edit: PropTypes.bool,
  lineType: PropTypes.string,
  options: PropTypes.string,
};

export default compose(withRouter)(ReviewSection);
